import React, {useState} from 'react';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';
import {AddOutlined, DeleteOutlined} from '@material-ui/icons';
import ContainedButton from '../../../../shared/buttons/ContainedButton.tsx';
import TabelaProcesso from '../../../components/processo/TabelaProcesso.jsx';
import {ouTraco} from '../../../components/inscricao/documentoInscricao.js';
import {descricaoTipoProcessoVestibular} from '../../../components/processo/processoSelecao.js';
import DialogProcessoVestibular from '../../../dialogs/processo/DialogProcessoVestibular.jsx';

/*
 * Subaba "Processos seletivos" da aba Inscrição (Ingressante e Colégio
 * Técnico): processos do vestibular permitidos. No Colégio Técnico só vale um.
 */
export default function TabInscricaoProcessosVestibular(props) {
    const {errors, idPrograma, unico, processosVestibular = [], processosVestibularApoio = [], onAlterarLista, onRemover} = props;
    const [dialogAberto, setDialogAberto] = useState(false);

    return (
        <>
            <Grid container spacing={3}>
                <TabelaProcesso
                    nome='processosVestibular'
                    errors={errors}
                    linhas={processosVestibular}
                    semRegistros='Nenhum processo seletivo selecionado.'
                    botao={(
                        <ContainedButton startIcon={<AddOutlined/>} onClick={() => setDialogAberto(true)}
                                         disabled={unico && processosVestibular.length > 0}>
                            {unico ? 'Selecionar' : 'Adicionar'}
                        </ContainedButton>
                    )}
                    colunas={[
                        {label: 'Código', field: 'idProcessoVestibular', valueGetter: valor => ouTraco(valor)},
                        {label: 'Descrição', field: 'descricao', valueGetter: valor => ouTraco(valor)},
                        {label: 'Tipo', field: 'tipo', valueGetter: valor => ouTraco(descricaoTipoProcessoVestibular(valor))}
                    ]}
                    acoes={(row, posicao) => [{
                        titulo: 'Excluir',
                        icone: <DeleteOutlined/>,
                        onClick: () => onRemover('processosVestibular', processosVestibular, posicao, 'Tem certeza que deseja remover esse processo seletivo?')
                    }]}/>
            </Grid>
            <DialogProcessoVestibular
                open={dialogAberto}
                onClose={() => setDialogAberto(false)}
                processos={processosVestibularApoio}
                processosVestibular={processosVestibular}
                idPrograma={idPrograma}
                onAdicionar={processo => onAlterarLista('processosVestibular', [...processosVestibular, processo])}/>
        </>
    );
}

TabInscricaoProcessosVestibular.propTypes = {
    errors: PropTypes.object.isRequired,
    idPrograma: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    /* Colégio Técnico: no máximo um processo. */
    unico: PropTypes.bool,
    processosVestibular: PropTypes.array,
    /* Processos do vestibular do apoio: [{id, descricao, tipo}]. */
    processosVestibularApoio: PropTypes.array,
    onAlterarLista: PropTypes.func.isRequired,
    onRemover: PropTypes.func.isRequired
};
